import { Component, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { GloamInstrument } from "@/components/gloam/instrument";
import "../src/styles.css";

class InstrumentBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return (
      <main role="alert" style={{ padding: "2rem", maxWidth: "36rem", margin: "auto" }}>
        <h1>Gloam could not start</h1>
        <p>Reload the page to try again. Saved patches in this browser are kept.</p>
        <button type="button" onClick={() => window.location.reload()}>Reload instrument</button>
      </main>
    );
    return this.props.children;
  }
}

const container = document.getElementById("root");
if (!container) throw new Error("Instrument root is missing");
createRoot(container).render(<InstrumentBoundary><GloamInstrument /></InstrumentBoundary>);
